<template>
    <div>
      <Header class="inline-block">
        <template v-slot:title><span class="text-lg capitalize">Experiencia Laboral</span></template>
      </Header>
      <div class="relative pl-px overflow-hidden timeline-job">
          <div v-for="(job, index) in data" :key="index" class="pl-6 mb-10 border-l-3 border-tertiary">
              <p><small> {{ job.from }} - {{ job.to }} </small></p>
              <p class="text-2xl font-semibold">{{ job.company }}</p>
              <p class="text-base"> {{job.name}} </p>
          </div>
      </div>
    </div>
</template>

<script>
import data from '../data/experience'
import Header from './Header';

export default {
  components: {
    Header
  },
  data() {
    return {
      data: data
    }
  } 
};
</script>

<style scoped>
  .timeline-job:before {
    content:'';
    position: absolute;
    width: 0;
    left: 2px;
    top: 0;
    bottom: 0;
    border-right: 1px solid color-mod(var(--color-tertiary) a(70%));
  }
  .timeline-job:after {
    content:'';
    position: absolute;
    width: 5px;
    height: 5px;
    left: 0;
    margin-top: -5px;
    background-color: var(--color-tertiary);
  }
</style>
